import PropTypes from 'prop-types';
import { deprecatedComponent } from '../core/deprecated-component.js';
import { createComponent } from '../core/create-component.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';

const propTypes = {
    /**
   * The visual style of the PromoBar
   */ skin: PropTypes.oneOf([
        'standard',
        'holiday',
        'holiday-green',
        'holiday-beige',
        'discount',
        'inverse'
    ])
};
/**
 * @deprecated Use a pattern of other SWAN components instead
 */ const PromoBar = deprecatedComponent({
    displayName: 'PromoBar',
    description: 'PromoBar is deprecated; use a pattern of other SWAN components instead',
    root: createComponent({
        displayName: 'PromoBar',
        root: 'div',
        propTypes,
        requiredStyleKeys: SWAN_STYLE_KEY_MAP.promoBar,
        propConfig: {
            classNames (props) {
                const classesSet = new Set([
                    'swan-promo-bar'
                ]);
                if (props.skin && props.skin !== 'standard') classesSet.add(`swan-promo-bar-skin-${props.skin}`);
                return classesSet;
            }
        }
    })
});
PromoBar.defaultProps = {
    skin: 'standard'
};

export { PromoBar };
